import { QueryFunction } from '@tanstack/react-query';
import queryString from 'query-string';

import { makeRequest } from '@app/utils';

import { getCQLState } from '../utils';
import { SearchResultsDto, SearchState } from '../constants';
import { useUrlManager } from './useUrlManager';

export const fetchSearch = (searchState: SearchState, expandAll = false) =>
  makeRequest<SearchResultsDto>({
    url: '/search/instances',
    params: {
      expandAll,
      ...getCQLState(searchState),
    },
    paramsSerializer: params => queryString.stringify(params),
  }).catch(error => {
    throw error?.response?.data;
  });

export const useSearchRequest = (
  state: SearchState
): QueryFunction<SearchResultsDto> => {
  const { updateUrl } = useUrlManager();

  return ({ queryKey }) => {
    const searchState = queryKey[1] as SearchState;

    if (!state.isInnerUpdate) {
      updateUrl(searchState);
    }

    return fetchSearch(searchState, true);
  };
};
